// import React, { memo } from 'react';
// import {
// 	ProgressIndicatorProps,
// 	ProgressIndicatorThemeProps,
// 	ProgressIndicatorTypeTokens,
// } from '@voltmoney/schema';
// import ThemeProvider from '@voltmoney/theme';
// import { ProgressIndicatorBase } from './ProgessIndicator.base';
// const ProgressIndicator: React.FunctionComponent<
// 	ProgressIndicatorProps
// > = ({ type, ...props }) => {
// 	/**
// 	 *  logic -> base-component(...props)
// 	 * */
// 	const theme = ThemeProvider.getTheme();
// 	const progressIndicatorThemeProps: ProgressIndicatorThemeProps =
// 		theme.progressIndicator[
// 		type || ProgressIndicatorTypeTokens.default
// 		];
// 	switch (type) {
// 		case ProgressIndicatorTypeTokens.default:
// 			return (
// 				<ProgressIndicatorBase
// 					{...progressIndicatorThemeProps}
// 					{...props}
// 				/>
// 			);
// 		case ProgressIndicatorTypeTokens.LINEAR:
// 			return (
// 				<ProgressIndicatorBase
// 					{...progressIndicatorThemeProps}
// 					{...props}
// 				/>
// 			);
// 		default:
// 			return <></>;
// 	}
// 	// return (
// 	// 	<ProgressIndicatorBase
// 	// 		{...progressIndicatorThemeProps}
// 	// 		{...props}
// 	// 	/>
// 	// );
// };
// export default memo(ProgressIndicator);
// export { ProgressIndicator };
import React, { memo } from 'react';
import { ProgressIndicatorTypeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { ProgressIndicatorBase, } from './ProgessIndicator.base';
import LinearProgressIndicatorBase from './LinearProgressIndicator.base';
/**
 * Primary UI component for user interaction
 */
const ProgressIndicator = ({ type, ...props }) => {
    /**
     *  logic -> base-component(...props)
     * */
    const theme = ThemeProvider.getTheme();
    const progressIndicatorThemeProps = theme.progressIndicator[type];
    switch (type) {
        case ProgressIndicatorTypeTokens.default:
            return (React.createElement(ProgressIndicatorBase, { ...progressIndicatorThemeProps, ...props }));
        case ProgressIndicatorTypeTokens.LINEAR:
            return (React.createElement(LinearProgressIndicatorBase, { ...progressIndicatorThemeProps, ...props }));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(ProgressIndicator);
export { ProgressIndicator };
